import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const GroupService = {};

GroupService.getGroups = async function (page, limit, categoryId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/get`,
        params: {
            page: page - 1,
            limit: limit,
            categoryId: categoryId === undefined ? null : categoryId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

GroupService.getGroupsForCertificateCreate = async function (page, limit) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/get`,
        params: {
            page: page - 1,
            limit: limit,
            forCertsCreate: true
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

GroupService.downloadTeachersDataExcel = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/group/get/excel/teachers",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

GroupService.downloadTeachersAccountExcel = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/group/get/excel/teachers-account",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

GroupService.downloadTeachersACW = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/group/get/excel/teachers-acw",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

GroupService.downloadTeachersFoundation = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/group/download/foundation",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

GroupService.downloadExcelGroupsStudentsData = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/group/get/excel/students",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

GroupService.deleteGroupById = async function (id) {
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/group/delete/${id}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.getGroup = async function (groupId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/teacher/group/get/${groupId}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.getTeacherByID = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/teacher/get`,
        params: {
            id: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.getGroupStudents = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/students/get`,
        params: {
            id: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.getGroupsByTeacher = async function (page, limit, teacherId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/teacher/group/get`,
        params: {
            page: page - 1,
            limit: limit,
            id: teacherId === undefined ? null : teacherId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    return response.data;
}

GroupService.getGroupsByStudent = async function (studentId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/group/get`,
        params: {
            studentId: studentId === undefined ? null : studentId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    return response.data;
}

GroupService.getGroupOfStudent = async function (groupId, userId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/student/journal/get`,
        params: {
            groupId: groupId,
            userId: userId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.getConductedClassesByTeacher = async function (teacherId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/teacher/statics/conductedClasses`,
        params: {
            id: teacherId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    return response.data;
}

GroupService.getNextGroupNumber = async function (name, courseId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/get/next-group-number`,
        params: {
            name: name,
            courseId: courseId,
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.1: текущий учебный год (для отображения рядом с кнопкой сброса нумерации).
GroupService.getGroupAcademicYear = async function (categoryId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/group/academic-year`,
        params: categoryId ? {categoryId} : {},
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.1: сброс нумерации групп «по кнопке» — перевод учебного года на следующий.
// ТЗ updated п.5: архивировать/разархивировать группу
GroupService.setGroupArchived = async function (groupId, archived) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/group/${groupId}/archive`,
        params: {archived: archived},
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// ТЗ updated п.5: разовая массовая архивация всех групп категории
GroupService.archiveGroupsByCategory = async function (categoryId, archived = true) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/group/archive/by-category`,
        params: {categoryId: categoryId, archived: archived},
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.resetGroupNumbering = async function (categoryId) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/group/reset-numbering`,
        params: categoryId ? {categoryId} : {},
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.saveGroup = async (nameKz, nameRu, nameEng, number, category, course, linkToWhatsAppGroup, teacher, students, foundEngGroup, foundReadGroup) => {
    let data = new FormData();
    data.append("nameKz", nameKz);
    data.append("nameRu", nameRu);
    data.append("nameEng", nameEng);
    data.append("number", number);
    data.append("categoryId", category);
    data.append("courseId", course);
    data.append("teacherId", teacher);
    // data.append("teacherContractNumber", teacherContractNumber);
    // data.append("teacherContractDate", teacherContractDate);
    if (linkToWhatsAppGroup !== undefined) {
        data.append("linkToWhatsAppGroup", linkToWhatsAppGroup);
    }
    if (students !== undefined) {
        data.append("students", students);
    }
    if (foundEngGroup !== undefined) {
        data.append("foundEngGroup", foundEngGroup);
    }
    if (foundReadGroup !== undefined) {
        data.append("foundEngGroup", foundReadGroup && 1);
    }

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/group/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.removeStudentFromGroup = async (groupId, studentId) => {
    let data = new FormData();
    data.append("groupId", groupId);
    data.append("studentId", studentId);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/group/remove-student",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.replaceGroupTeacher = async (groupId, teacherId) => {
    let data = new FormData();
    data.append("groupId", groupId);
    data.append("teacherId", teacherId);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/group/replace-teacher",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

GroupService.updateTeacherOrder = async (groupId, teacherContractNumber, teacherContractDate) => {
    let data = new FormData();
    data.append("groupId", groupId);
    data.append("teacherContractNumber", teacherContractNumber);
    data.append("teacherContractDate", teacherContractDate);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/group/update-teacher-order",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.6/п.7: даты присоединения учеников группы + порог низкой посещаемости
GroupService.getGroupEnrollments = async function (groupId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/group/enrollments`,
        params: {
            groupId: groupId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    return response.data;
}

// п.6/п.7: изменить дату присоединения ученика к группе (админ)
GroupService.setEnrollment = async function (groupId, studentId, joinDate) {
    let data = new FormData();
    data.append("groupId", groupId);
    data.append("studentId", studentId);
    data.append("joinDate", joinDate);
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/group/enrollment`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.10: полное расписание ученика по всем дисциплинам
GroupService.getStudentSchedule = async function (studentId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/group/student/schedule`,
        params: {
            studentId: studentId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    return response.data;
}

// fix joinDate: joinDate ('YYYY-MM-DD') необязателен — если не передать,
// бэкенд сам подставит дату первого занятия группы (а не сегодняшнюю дату)
GroupService.addStudents = async (groupId, students, joinDate) => {
    let data = new FormData();
    data.append("groupId", groupId);
    data.append("students", students);
    if (joinDate) {
        data.append("joinDate", joinDate);
    }

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/group/add-students",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default GroupService;